import RoomPlayerInstance from "./RoomPlayerInstance";
import { STATE, ACTIONS } from "../../../../Models/ENUM";
import ARRAY from "../../../../UTIL/ARRAY";

class RoomPlayerState
{
    private Player : RoomPlayerInstance;

    constructor( Player:RoomPlayerInstance )
    {
        this.Player    = Player;
    }
 
    public idle( data?:any )
    {
        this.set( STATE.IDLE, data );
    }

    public attack( data?:any )
    {
        this.set( STATE.ATTACK, data );
    }

    public dying( data?:any )
    {
        this.set( STATE.DYING, data );
    }

    public dead( data?:any )
    {
        this.set( STATE.DEAD, data );
    }

    public carry( data?:any )
    {
        this.set( STATE.CARRY, data );
    }

    public dance( data?:any )
    {
        this.set( STATE.DANCE, data );
    }

    public defeat( data?:any )
    {
        this.set( STATE.DEFEAT, data );
    }

    public walk( data?:any )
    {
        this.set( STATE.WALK, data );
    }

    public run( data?:any )
    {
        this.set( STATE.RUN, data );
    }

    public crazy( data?:any )
    {
        this.set( STATE.CRAZY, data );
    }

    public fall( data?:any )
    {
        this.set( STATE.FALL, data );
    }

    public wallrun( data?:any )
    {
        this.set( STATE.WALLRUN, data );
    }

    public slide( data?:any )
    {
        this.set( STATE.SLIDE, data );
    }

    public wallslide( data?:any )
    {
        this.set( STATE.WALLSLIDE, data );
    }

    public doublejump( data?:any )
    {
        this.set( STATE.DOUBLEJUMP, data );
    }
 
    private set( status:number, data?:any )
    {
        if( this.Player.data.status === status ) return;
        
        this.Player.Room.doSend( ACTIONS.PLAYERSTATE, ARRAY.extract({ status:status }, data ) );
    }

}

export default RoomPlayerState;